import { Link } from "react-router-dom";
import "./JourneyBanner.css";

export default function JourneyBanner() {
  return (
    <section className="journey" aria-label="timeline teaser">
      <div className="container">
        <div className="journey__inner">
          <p className="journey__eyebrow">the journey</p>
          <p className="journey__text">
            From first lines of code to hackathon wins — see every milestone in order.
          </p>
          <Link to="/timeline" className="btn btn-outline journey__btn">
            Explore the timeline
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
